import BaseAction from "./BaseAction";
import LoginReducer from "@common/redux/reducers/LoginReducer";

class LoginAction extends BaseAction {
  Login = async (data) => this.dispatch({ ...data });

  Logout = async () => this.reset();
}

const action = new LoginAction(LoginReducer);

export default action;
